/**
 *
 * @param {*} param0
 * @returns
 */
const Button = function ({ bg, border, text, children, className, ...rest }) {
  const classes = ["btn", className];
  if (bg) {
    classes.push(`color-bg-${bg}`);
  }
  if (border) {
    classes.push(`color-border-${border}`);
  }
  if (text) {
    classes.push(`color-text-${text}`);
  }
  return (
    <button
      className={classes.join(" ")}
      style={{ borderRadius: "2em" }}
      {...rest}
    >
      {children}
    </button>
  );
};

export default Button;
